import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-center-progress",
  templateUrl: "./center-progress.component.html",
  styleUrls: ["./center-progress.component.css"],
})
export class CenterProgressComponent implements OnInit {
  type = "中心历程";

  dian1 = false;
  dian2 = false;
  dian3 = false;
  dian4 = false;
  dian5 = false;
  dian6 = false;
  dian7 = false;
  dian8 = false;
  dian9 = false;
  dian10 = false;
  dian11 = false;
  dian12 = false;
  dian13 = false;
  dian14 = false;
  dian15 = false;
  dian16 = false;

  img = [
    {
      i: "../../resolution/assets/images/layout/serve/组 25.png",
      s: "卫星遥感数据分发服务",
    },
    {
      i: "../../resolution/assets/images/layout/serve/图层 7.png",
      s: "海量遥感数据预处理服务",
    },
    {
      i: "../../resolution/assets/images/layout/serve/图层 10.png",
      s: "批量遥感数据信息提取服务",
    },
    {
      i: "../../resolution/assets/images/layout/serve/图层 9.png",
      s: "大范围精准目标排查服务",
    },
    {
      i: "../../resolution/assets/images/layout/serve/图层 12.png",
      s: "综合遥感制图表达服务",
    },
    {
      i: "../../resolution/assets/images/layout/serve/图层 13.png",
      s: "空间信息综合分析评估服务",
    },
    {
      i: "../../resolution/assets/images/layout/serve/图层 14.png",
      s: "生态环境监测站设计规划服务",
    },
    {
      i: "../../resolution/assets/images/layout/serve/图层 15.png",
      s: "无人机遥感监测服务",
    },
    {
      i: "../../resolution/assets/images/layout/serve/图层 16.png",
      s: "3S空间地理信息综合应用服务",
    },
  ];
  constructor() {}
  
  time(num: number) {
    this.resetDian();
    this[`dian${num}`] = true;
  }

  resetDian() {
    for (let i = 1; i <= 16; i++) {
      this[`dian${i}`] = false;
    }
  }

  out1() {
    this.resetDian();
  }

  ngOnInit() {}
}
